import { render, staticRenderFns } from "./FormFive.vue?vue&type=template&id=5edaffb0&scoped=true"
import script from "./FormFive.vue?vue&type=script&lang=js"
export * from "./FormFive.vue?vue&type=script&lang=js"
import style0 from "./FormFive.vue?vue&type=style&index=0&id=5edaffb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edaffb0",
  null
  
)

export default component.exports